import { render, staticRenderFns } from "./CS2RecordingAndAuditLog.vue?vue&type=template&id=67cfbfe2&"
import script from "./CS2RecordingAndAuditLog.vue?vue&type=script&lang=js&"
export * from "./CS2RecordingAndAuditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports